"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const log_1 = require("../../model/log");
const material_1 = require("@mui/material");
const log_context_1 = require("../../context/log-context");
exports.IconButton = (0, react_1.memo)((0, react_1.forwardRef)((_a, ref) => {
    var { eventName } = _a, props = __rest(_a, ["eventName"]);
    const { logEvent } = (0, log_context_1.useLog)();
    const handleOnClick = (0, react_1.useCallback)((event) => {
        if (eventName) {
            logEvent(log_1.LogEventType.Click, eventName);
        }
        if (props.onClick) {
            props.onClick(event);
        }
    }, [eventName, logEvent, props]);
    return (0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({}, props, { onClick: handleOnClick, ref: ref }));
}));
exports.IconButton.displayName = "IconButton";
